// import { AccessTokenResponse, RoleDocument, User } from 'commons/models/marketingDashboard';

import Cookies from 'universal-cookie';
import { LUDO_SUPREME_DOMAIN } from '../constants';
import { parseJSON, parseString } from './helper';

const cookies = new Cookies();

export const removeToken = () => {
	localStorage.removeItem('token');
	cookies.remove('token', { path: '/', domain: LUDO_SUPREME_DOMAIN });
};

export const getToken = (): any => {
	const tokenString = localStorage.getItem('token');
	return parseJSON(tokenString);
};

export const getZupeeEnv = (): string => {
	return cookies.get('x-zupee-env');
};

export const getStageEnvId = (): string => {
	return cookies.get('z-stage-env-id');
};

export const setStageEnvId = (envId: string): void => {
	cookies.set('z-stage-env-id', envId);
};
export const setToken = (token: { success: boolean; accessToken: any; data: { user: any; userRole: any } }) => {
	const tokenString = parseString(token);
	localStorage.setItem('token', tokenString);
};

export const findStageEnvId = () => {
	const currentToken = localStorage.getItem('token');
	const tokenData = currentToken ? JSON.parse(currentToken) : null;
	const zupeeEmail = tokenData?.data?.user?.email;
	const envId = zupeeEmail?.split('@')[0]?.replace(/\./g, '-');
	return envId;
};

export const setTokenToCookies = (token: { success: boolean; accessToken: any; data: { user: any; userRole: any } }) => {
	cookies.set('token', token?.accessToken?.accessToken, {
		domain: LUDO_SUPREME_DOMAIN,
		path: '/'
	});

	cookies.set('x-zupee-env', 'cse');

	cookies.set('z-stage-env-id', findStageEnvId() || null);
};

export const updateToken = (key: any, value: any) => {
	const oldToken = getToken();
	const newToken = { ...oldToken, [key]: value };
	setToken(newToken);
};
export const getUserDetails = () => {
	const { token } = getToken();
	const userDetails = atob(token).split(':');
	const userName = userDetails[0];
	const password = userDetails[1];
	return { password, userName };
};

export default {
	removeToken,
	getToken,
	setToken,
	getUserDetails
};
